import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkGetLatestReadings } from '../types';

const onGetLatestReadings: IThunkGetLatestReadings = thunk(
  // @ts-ignore
  async ({ setLatestReadings }, patientId) => {
    const data = await api.patients.getLatestReadings(patientId).then(res => res.data);

    setLatestReadings(data);
  },
);

export default onGetLatestReadings;
